module.exports = __webpack_public_path__ + "static/media/actual-arrow-left-rounded.8cf1d70c.svg";